import React, { useEffect, useState } from 'react';
import { useEHRContext } from 'contexts/EHRContext';
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
} from '@material-ui/lab';
import { fixTimezoneOffset, monthNames } from 'utils/dateFunctions';
import '../TemplateTab/TemplateTab.css';
import { DocumentsCard } from '../DocumentsCard';
import { DocumentsVisualizer } from '../DocumentsVisualizer';
import { EmptyFieldWarning } from '../EmptyFieldWarning';
import xdsToken from 'services/xdsToken';
import { logDebug, retrieveData } from 'utils/AuxiliarFunctions';
import axios from 'axios';
import { ToastMessage } from 'components';
import { toast } from 'react-toastify';
import { currentMode, endpoints } from 'configs';
import { LoadMoreButton } from '../LoadMoreButton';

export function DiagnosticReportTab({ page }) {
  const { diagnosticReport, ehrState } = useEHRContext();

  const [modalContent, setModalContent] = useState({});
  const [paginationNextUrl, setPaginationNextUrl] = useState('');
  const [timelineList, setTimelineList] = useState([]);
  const [loadingMoreDocuments, setLoadingMoreDocuments] = useState(false);

  const diagnosticReportResults =
    timelineList?.filter(
      (element) => element.resource?.resourceType === 'DiagnosticReport',
    ) || [];

  const serviceRequests =
    timelineList?.filter(
      (element) => element.resource?.resourceType === 'ServiceRequest',
    ) || [];
  // ?.filter(((diagnosticReportElement) => diagnosticReportElement.resource.category[0])));

  const [filter, setFilter] = useState('');
  const [selectedIndex, setSelectedIndex] = useState(1);
  const slicedTable = filter
    ? diagnosticReportResults.filter(
        (diagnosticReportElement) =>
          diagnosticReportElement.resource?.category?.[0].coding[0].display ===
          filter,
      ) || []
    : diagnosticReportResults || [];

  const dateCards = [];
  slicedTable.forEach((diagnosticReportElement) => {
    const isoDate = diagnosticReportElement?.resource?.issued || '';
    const month =
      monthNames[fixTimezoneOffset(new Date(isoDate)).getMonth() + 1];
    const year = fixTimezoneOffset(new Date(isoDate)).getFullYear();
    if (!dateCards.includes(`${month} - ${year}`))
      dateCards.push(`${month} - ${year}`);
    else dateCards.push('');
  });

  async function getTokens() {
    await xdsToken.getBearerToken();
    const bearerToken = await retrieveData('application_token');
    const xUserToken = await retrieveData('token');
    return { bearerToken, xUserToken };
  }

  function handleUpdateTimeline() {
    try {
      if (paginationNextUrl) {
        setLoadingMoreDocuments(true);
        const link = `${endpoints.MHD}?${paginationNextUrl.split('?')[1]}`;

        getTokens().then((tokens) => {
          const headers = {
            authorization: `Bearer ${
              ehrState.subject.token || tokens.bearerToken
            }`,
            'x-user-Token': `${ehrState.subject.token || tokens.xUserToken}`,
            'Content-Type': 'application/fhir+json',
            Accept: 'application/fhir+json',
            purposeofuse: 'Atendimento',
            ...(ehrState.subject.organizationId && {
              'organization-id': ehrState.subject.organizationId,
            }),
            ...(ehrState.resource.id &&
              currentMode === 'aghu' && {
                'resource-id': ehrState.resource.id,
              }),
            ...(ehrState.subject.id && { 'subject-id': ehrState.subject.id }),
          };
          axios({
            method: 'get',
            url: link,
            headers,
            timeout: 5000,
          })
            .then(async ({ data: response }) => {
              toast.success(
                <ToastMessage type="success">
                  {' '}
                  Requisição completada.
                </ToastMessage>,
              );
              setTimelineList([...timelineList, ...response.entry]);
              setPaginationNextUrl(
                response.link.find(({ relation }) => relation === 'next')?.url,
              );
            })
            .catch((err) => {
              try {
                logDebug(err);
                toast.error(
                  <ToastMessage type="error">
                    {' '}
                    Requisição completada.
                  </ToastMessage>,
                );
              } catch {
                // toast de error
              }
            })
            .then(() => {
              setLoadingMoreDocuments(false);
            });
        });
      }
    } catch (err) {
      logDebug(err);
    }
  }

  useEffect(() => {
    if (Array.isArray(diagnosticReport?.link)) {
      setPaginationNextUrl(
        diagnosticReport?.link.length > 1
          ? diagnosticReport?.link.find(({ relation }) => relation === 'next')
              .url
          : '',
      );
    }
    if (Array.isArray(diagnosticReport?.entry))
      setTimelineList(diagnosticReport?.entry);
  }, [diagnosticReport]);

  return (
    <>
      <div className={page ? 'EHRArea-tabs' : 'EHRfilterButtons'}>
        <button
          className={
            filter === '' &&
            (page ? 'EHRArea-openTab' : 'EHRfilterButtons-selected')
          }
          onClick={() => {
            setFilter('');
          }}
        >
          Todos os exames
        </button>
        {/* <button
          className={
            filter === 'Laboratory' &&
            (page ? 'EHRArea-openTab' : 'EHRfilterButtons-selected')
          }
          onClick={() => {
            setFilter('Laboratory');
          }}
        >
          Exames laboratoriais
        </button>
        <button
          className={
            filter === 'Diagnostic Imaging' &&
            (page ? 'EHRArea-openTab' : 'EHRfilterButtons-selected')
          }
          onClick={() => {
            setFilter('Diagnostic Imaging');
          }}
        >
          Exames de imagem
        </button> */}
      </div>

      {slicedTable.length ? (
        <div className="documentsTab-containter">
          <div className="ehrTimeline-container">
            <Timeline>
              {slicedTable?.map((diagnosticReportElement, index) => {
                const findRequester = serviceRequests?.find(
                  (serviceRequestElement) =>
                    serviceRequestElement?.resource?.id ===
                    diagnosticReportElement?.resource?.basedOn?.[0]?.reference?.split(
                      '/',
                    )?.[1],
                );
                const auxPractitioner =
                  findRequester?.resource?.contained?.[0]?.name?.[0]?.text ||
                  'Não encontrado';
                const auxDate = diagnosticReportElement?.resource?.issued || '';

                const auxOccurenceDate =
                  findRequester?.resource?.occurrenceDateTime || undefined;

                const auxOrganizationAliasRequest =
                  findRequester?.resource?.code.text || '';

                const auxType =
                  diagnosticReportElement.resource.code.text || '';
                const auxOrganization =
                  diagnosticReportElement?.resource?.contained?.find(
                    ({ resourceType }) => resourceType === 'Organization',
                  );

                // const auxOrganizationId = auxOrganization.identifier[0].value;
                const auxOrganizationAlias = auxOrganization.alias
                  ? auxOrganization.alias[0]
                  : auxOrganization.name || 'Não Encontrado';
                const auxOrganizationName =
                  auxOrganization && auxOrganization.name;
                const auxDocumentBinaryId =
                  diagnosticReportElement.resource.presentedForm[0].url;
                return (
                  <>
                    {dateCards[index] && (
                      <TimelineItem
                        key={`timelineDateItemCard-${dateCards[index]}`}
                      >
                        <TimelineSeparator>
                          <TimelineDot className="highlight" />
                          <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent>
                          <div className="ehrTimeline-dateCard">
                            {dateCards[index]}
                          </div>
                        </TimelineContent>
                      </TimelineItem>
                    )}
                    <TimelineItem
                      key={`timelineItemCard-${diagnosticReportElement.resource.id}`}
                    >
                      <TimelineSeparator>
                        <TimelineDot />
                        {index !== slicedTable.length - 1 && (
                          <TimelineConnector />
                        )}
                      </TimelineSeparator>
                      <TimelineContent>
                        <DocumentsCard
                          selectedIndex={selectedIndex}
                          index={index}
                          setSelectedIndex={setSelectedIndex}
                          setModalContent={setModalContent}
                          documentBinaryId={auxDocumentBinaryId}
                          date={auxDate || ''}
                          occurenceDate={auxOccurenceDate}
                          type={auxType}
                          organizationName={auxOrganizationName}
                          binary={auxDocumentBinaryId}
                          description={`Profissional solicitante: ${auxPractitioner}`}
                          alias={auxOrganizationAlias}
                          auxOrganizationAliasRequest={
                            auxOrganizationAliasRequest
                          }
                          pacs={diagnosticReportElement.resource.id}
                          imaging={filter === 'Diagnostic Imaging'}
                        />
                      </TimelineContent>
                    </TimelineItem>
                  </>
                );
              })}
            </Timeline>
            {paginationNextUrl && (
              <LoadMoreButton onClick={handleUpdateTimeline} />
            )}
          </div>

          {modalContent.link && (
            <DocumentsVisualizer modalContent={modalContent} />
          )}
        </div>
      ) : (
        <EmptyFieldWarning />
      )}
    </>
  );
}
